import axios from '@/utils/axios';

//根据3sclone的speakerid获取speaker信息
export const get3sCloneSpeakerById= (speakerId: string) => {
  return axios.get(`/apis/tts-web-api/v1/speaker/speakerId?speakerId=${speakerId}`);
};

